module.exports = __webpack_public_path__ + "static/media/form-graphic.f94df652.svg";